export const TextFragmentApi = (function () {
  const isSupported = () => {
    return 'fragmentDirective' in document;
  };

  const generateUrl = (selectedText, range) => {
    const baseUrl = window.location.href.split('#')[0];

    if (!selectedText) {
      return baseUrl;
    }

    try {
      if (range && range.startContainer.nodeType === Node.TEXT_NODE) {
        const containerText = range.startContainer.textContent || '';

        const isStartFromWordBeginning =
          range.startOffset === 0 ||
          containerText[range.startOffset - 1] === ' ' ||
          containerText[range.startOffset - 1] === '\n' ||
          containerText[range.startOffset - 1] === '\t';

        const isEndAtWordEnd =
          range.startOffset + selectedText.length === containerText.length ||
          containerText[range.startOffset + selectedText.length] === ' ' ||
          containerText[range.startOffset + selectedText.length] === '\n' ||
          containerText[range.startOffset + selectedText.length] === '\t' ||
          containerText[range.startOffset + selectedText.length] === '.';

        const cleanSelectedText = selectedText.trim().replace(/\.$/, '');

        // Check if text is long (more than 7 words)
        const words = cleanSelectedText.split(/\s+/);
        const isLongText = words.length > 7;

        if (isStartFromWordBeginning && isEndAtWordEnd && !isLongText) {
          const textFragment = encodeURIComponent(cleanSelectedText);
          return `${baseUrl}#:~:text=${textFragment}`;
        }

        // For partial word selection or long text, find context
        const beforeText = containerText.substring(0, range.startOffset);
        const afterText = containerText.substring(
          range.startOffset + selectedText.length,
        );

        const startWord =
          beforeText
            .split(/\s+/)
            .filter((word) => word.length > 0)
            .pop() || '';

        // Remove dot at the end of sentence from afterText before getting endWord
        const cleanAfterText = afterText.replace(/^\s*\.\s*/, '');
        const endWord =
          cleanAfterText.split(/\s+/).filter((word) => word.length > 0)[0] ||
          '';

        let textFragment = '';

        if (isLongText) {
          // For long text with partial words
          let startFragment = '';
          let endFragment = '';

          if (!isStartFromWordBeginning && startWord) {
            startFragment = `${encodeURIComponent(startWord)}-,`;
          }
          startFragment += encodeURIComponent(words.slice(0, 3).join(' '));

          endFragment = encodeURIComponent(words.slice(-3).join(' '));
          if (!isEndAtWordEnd && endWord) {
            endFragment += `,-${encodeURIComponent(endWord)}`;
          }

          textFragment = `${startFragment},${endFragment}`;
        } else {
          if (startWord) {
            textFragment += `${encodeURIComponent(startWord)}-,`;
          }
          textFragment += encodeURIComponent(cleanSelectedText);
          if (endWord) {
            textFragment += `,-${encodeURIComponent(endWord)}`;
          }
        }

        return `${baseUrl}#:~:text=${textFragment}`;
      }
    } catch (e) {
      console.warn('Error when trying to get context:', e);
    }

    // Fallback if something went wrong - clean from trailing dot
    const cleanSelectedText = selectedText.trim().replace(/\.$/, '');
    const words = cleanSelectedText.split(/\s+/);

    if (words.length > 7) {
      const startWords = words.slice(0, 3).join(' ');
      const endWords = words.slice(-3).join(' ');
      const textFragment = `${encodeURIComponent(startWords)},${encodeURIComponent(endWords)}`;
      return `${baseUrl}#:~:text=${textFragment}`;
    } else {
      const textFragment = encodeURIComponent(cleanSelectedText);
      return `${baseUrl}#:~:text=${textFragment}`;
    }
  };

  const copyLink = (selectedText, range) => {
    if (!selectedText) {
      return window.location.href;
    }

    const url = generateUrl(selectedText, range);
    navigator.clipboard
      .writeText(url)
      .catch((err) => console.error('Error when copying:', err));
    return url;
  };

  const addHighlightStyles = () => {
    const style = document.createElement('style');
    style.textContent = `
      ::target-text {
        background-color: yellow;
        color: black;
      }
    `;
    document.head.appendChild(style);
  };

  return {
    isSupported,
    generateUrl,
    copyLink,
    addHighlightStyles,
  };
})();
